export const UPDATE_SCHEMA = `
    mutation updateGQLSchema($sch: String!) {
        updateGQLSchema(input: { set: { schema: $sch } }) {
            gqlSchema {
                schema
                generatedSchema
            }
        }
    }
`;
